import { WorkflowTriggerType } from 'src/graphql/entities/workflow/workflow.trigger';
import type { CreatedWorkflowWithFirstVersion } from 'src/graphql/entities/workflow/workflow.types';

export enum NewWorkflowField {
  Name = 'name',
  TriggerType = 'triggerType',
  Description = 'description',
  StartFrom = 'startFrom',
  VersionDescription = 'versionDescription',
}

/** The Start from value for a blank version 1; any other value is the id of a workflow to copy. */
export const START_FROM_BLANK = 'blank';

export interface NewWorkflowFormValues {
  [NewWorkflowField.Name]: string;
  [NewWorkflowField.TriggerType]: WorkflowTriggerType;
  [NewWorkflowField.Description]: string;
  [NewWorkflowField.StartFrom]: string;
  [NewWorkflowField.VersionDescription]: string;
}

export interface NewWorkflowModalProps {
  /** Copy to new workflow: the trigger of the workflow on screen. */
  initialTriggerType?: WorkflowTriggerType;
  /** Copy to new workflow: the workflow on screen, whose active version is the start. */
  initialSourceWorkflowId?: string | null;
  /** Called with the new workflow and its version 1; the dialog closes without waiting on it. */
  onCreated?: (result: CreatedWorkflowWithFirstVersion) => void | Promise<void>;
}

export function getNewWorkflowDefaultValues({
  initialTriggerType,
  initialSourceWorkflowId,
}: Pick<
  NewWorkflowModalProps,
  'initialTriggerType' | 'initialSourceWorkflowId'
>): NewWorkflowFormValues {
  return {
    [NewWorkflowField.Name]: '',
    [NewWorkflowField.TriggerType]: initialTriggerType ?? WorkflowTriggerType.InboundPhoneCall,
    [NewWorkflowField.Description]: '',
    [NewWorkflowField.StartFrom]: initialSourceWorkflowId ?? START_FROM_BLANK,
    [NewWorkflowField.VersionDescription]: '',
  };
}
